import { Link } from "react-router-dom";
import Footer from "../../../components/footer/Footer";
import Imagewheel from "../../../components/imagewheel/Imagewheel";
import Newsletter from "../../../components/newsletter/Newsletter";
import {
  WorkCard,
  WorkCardIcon,
  WorkCardsCardContainer,
  WorkCardsContainer,
  WorkCardsTextContainer,
  WorkCardText,
  WorkCardTitle,
  WorkIntroductionButton,
  WorkIntroductionContainer,
  WorkIntroductionImage,
  WorkIntroductionIntroTitle,
  WorkIntroductionText,
  WorkIntroductionTextContainer,
  WorkIntroductionTitle,
  WorkPageContainer,
  WorkWhyCard,
  WorkWhyCardSection,
  WorkWhyCardText,
  WorkWhyCardTextContainer,
  WorkWhyCardTextTitle,
  WorkWhyContainer,
  WorkWhyDescription,
  WorkWhyIcon,
  WorkWhyImage,
  WorkWhySection,
  WorkWhyTextContainer,
  WorkWhyTextHeader,
} from "./WorkStyles";
import {
  faBriefcase,
  faClock,
  faHandshake,
  faLayerGroup,
  faMedal,
  faUserMd,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";

function Work() {
  const images = ["/assets/15.jpg", "/assets/16.jpg", "/assets/17.jpg"];

  return (
    <WorkPageContainer>
      {/* Healthcare - Work: Imagewheel */}
      <Imagewheel images={images} isWork={true} />

      {/* Healthcare - Work: Introduction */}
      <WorkIntroductionContainer>
        <WorkIntroductionTextContainer>
          <WorkIntroductionIntroTitle>
            Beschikbare vacatures
          </WorkIntroductionIntroTitle>
          <WorkIntroductionTitle>
            Zoek nu in onze beschikbare vacature of periode opdrachten
          </WorkIntroductionTitle>
          <WorkIntroductionText>
            Stuur ons je CV en motivatie, en wij gaan direct voor je aan de slag
            om de beste match voor je te vinden. Op onze website kun je ook
            eenvoudig de nieuwste vacatures bekijken en direct solliciteren.
          </WorkIntroductionText>
          <Link to="/apply" style={{ textDecoration: "none" }}>
            <WorkIntroductionButton>Direct aanmelden</WorkIntroductionButton>
          </Link>
        </WorkIntroductionTextContainer>
        <WorkIntroductionImage src="/assets/21.jpg" alt="Smart Personeel" />
      </WorkIntroductionContainer>

      {/* Healthcare - Work: Cards */}
      <WorkCardsContainer>
        <WorkCardsTextContainer>
          <WorkIntroductionIntroTitle>
            Werken bij Smart
          </WorkIntroductionIntroTitle>
          <WorkIntroductionTitle>
            Better Work, Better Life!
          </WorkIntroductionTitle>
        </WorkCardsTextContainer>
        <WorkCardsCardContainer>
          <WorkCard>
            <WorkCardIcon icon={faUserTie} />
            <WorkCardTitle>ZZP</WorkCardTitle>
            <WorkCardText>
              Als zzp’er bieden wij je de vrijheid om te werken zoals jij wilt,
              met de zekerheid van een betrouwbare partner. Wij regelen alles
              van planning tot facturatie en zorgen ervoor dat je overeenkomsten
              wet DBA-proof zijn. Je kunt losse diensten aannemen, werken op
              projectbasis of onderdeel worden van ons flexteam. Met minimaal 3
              jaar ervaring kun je je bij ons aanmelden en aan de slag!
            </WorkCardText>
          </WorkCard>

          <WorkCard>
            <WorkCardIcon icon={faBriefcase} />
            <WorkCardTitle>Loondienst</WorkCardTitle>
            <WorkCardText>
              Als je liever in loondienst werkt, bieden wij je een vaste
              werkplek in een stabiele en dynamische zorgomgeving. Wij zorgen
              voor een goed salaris en nemen de administratieve rompslomp uit
              handen. Bij ons werk je met de zekerheid van een vast contract en
              de vrijheid om je werk af te stemmen op jouw ambities. Neem
              contact met ons op voor meer informatie.
            </WorkCardText>
          </WorkCard>

          <WorkCard>
            <WorkCardIcon icon={faHandshake} />
            <WorkCardTitle>Detachering</WorkCardTitle>
            <WorkCardText>
              Als je liever gedetacheerd werkt, bieden wij je een vaste of
              flexibele opdracht voor een bepaalde periode. Wij zorgen voor een
              goed salaris en nemen de administratieve rompslomp uit handen. Bij
              ons werk je met de zekerheid van een vast contract en de vrijheid
              om je werk af te stemmen op jouw ambities. Neem contact met ons
              op, zodat we samen naar passende mogelijkheden kunnen kijken
            </WorkCardText>
          </WorkCard>

          <WorkCard>
            <WorkCardIcon icon={faLayerGroup} />
            <WorkCardTitle>Combinatie</WorkCardTitle>
            <WorkCardText>
              Op zoek naar de flexibiliteit van zowel zzp als loondienst? Bij
              Smart-Personeel bieden we de mogelijkheid om beide te combineren.
              Dit geeft je de vrijheid om te schakelen tussen een vast salaris
              en het zelfstandig ondernemen, afhankelijk van jouw wensen en
              situatie. Wij zorgen ervoor dat alles soepel verloopt, zodat jij
              kunt kiezen wat het beste bij je past.
            </WorkCardText>
          </WorkCard>
        </WorkCardsCardContainer>
      </WorkCardsContainer>

      {/* Healthcare - Work: Why */}
      <WorkWhyContainer>
        <WorkWhySection>
          <div>
            <WorkWhyImage src="/assets/22.jpg" />
          </div>

          <WorkWhyTextContainer>
            <WorkWhyTextHeader>Waarom kiezen voor Smart?</WorkWhyTextHeader>
            <WorkWhyDescription>
              Smart-Personeel begrijpt de unieke uitdagingen binnen de
              zorgsector en biedt op maat gemaakte oplossingen die aansluiten
              bij de specifieke behoeften van zowel zorginstellingen als
              zorgprofessionals.
            </WorkWhyDescription>
            <WorkWhyCardSection>
              <WorkWhyCard>
                <WorkWhyIcon icon={faUserMd} />
                <WorkWhyCardTextContainer>
                  <WorkWhyCardTextTitle>Ervaring</WorkWhyCardTextTitle>
                  <WorkWhyCardText>
                    Met jarenlange ervaring in de zorgsector heeft
                    Smart-Personeel een bewezen staat van dienst in het
                    succesvol plaatsen van gekwalificeerde zorgprofessionals
                  </WorkWhyCardText>
                </WorkWhyCardTextContainer>
              </WorkWhyCard>

              <WorkWhyCard>
                <WorkWhyIcon icon={faMedal} />
                <WorkWhyCardTextContainer>
                  <WorkWhyCardTextTitle>Prestigieus</WorkWhyCardTextTitle>
                  <WorkWhyCardText>
                    Smart-Personeel heeft een sterke reputatie opgebouwd door
                    consistent hoogwaardige diensten te leveren.
                  </WorkWhyCardText>
                </WorkWhyCardTextContainer>
              </WorkWhyCard>

              <WorkWhyCard style={{ marginBottom: "40px" }}>
                <WorkWhyIcon icon={faClock} />
                <WorkWhyCardTextContainer>
                  <WorkWhyCardTextTitle>
                    24/7 Ondersteuning
                  </WorkWhyCardTextTitle>
                  <WorkWhyCardText>
                    De zorg stopt nooit, en daarom biedt Smart-Personeel 24/7
                    ondersteuning.
                  </WorkWhyCardText>
                </WorkWhyCardTextContainer>
              </WorkWhyCard>
            </WorkWhyCardSection>
          </WorkWhyTextContainer>
        </WorkWhySection>
      </WorkWhyContainer>

      {/* Healthcare - Work: Newsletter */}
      <Newsletter />

      {/* Healthcare - Work: Footer */}
      <Footer />
    </WorkPageContainer>
  );
}

export default Work;
